/* Banner da Black November na página inicial: contagem regressiva real e
   o banner some sozinho depois do fim da campanha.
   No carrossel da Home (anina-hero), o slide inteiro sai: o Liquid já não o
   desenha depois do fim, e este script tira o slide de páginas que ficaram
   em cache, sem deixar ponto nem seta sobrando. */
class AninaBFBanner extends HTMLElement {
  connectedCallback() {
    clearInterval(this.timer);
    const ini = Date.parse(this.dataset.inicio || '');
    const fim = Date.parse(this.dataset.fim || '');
    const box = this.querySelector('[data-contagem]');
    if (Number.isNaN(fim)) return;
    const rotulo = box?.querySelector('[data-contagem-rotulo]');
    const nums = {};
    box?.querySelectorAll('[data-u]').forEach((el) => (nums[el.dataset.u] = el));

    const tick = () => {
      const agora = Date.now();
      let alvo;
      if (!Number.isNaN(ini) && agora < ini) {
        alvo = ini;
        if (rotulo) rotulo.textContent = 'Começa em';
      } else if (agora < fim) {
        alvo = fim;
        if (rotulo) rotulo.textContent = 'Termina em';
      } else {
        clearInterval(this.timer);
        this.encerrar();
        return;
      }
      if (!box) return;
      box.hidden = false;
      const s = Math.max(0, Math.floor((alvo - agora) / 1000));
      const v = { dias: Math.floor(s / 86400), horas: Math.floor((s % 86400) / 3600), min: Math.floor((s % 3600) / 60), seg: s % 60 };
      for (const k in v) {
        const txt = String(v[k]).padStart(2, '0');
        if (nums[k] && nums[k].textContent !== txt) nums[k].textContent = txt;
      }
    };
    tick();
    this.timer = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  /* Fim da campanha: tira o slide do carrossel (ou esconde a seção, fora do carrossel) */
  encerrar() {
    const hero = this.closest('anina-hero');
    const slide = this.closest('[data-slide]');
    if (!hero || !slide) {
      (this.closest('.shopify-section') || this).hidden = true;
      return;
    }

    slide.remove();
    const pontos = hero.querySelectorAll('[data-dot]');
    pontos[pontos.length - 1]?.remove();

    const slides = [...hero.querySelectorAll('[data-slide]')];
    slides.forEach((s, k) => s.setAttribute('aria-label', `${k + 1} de ${slides.length}`));
    if (slides.length < 2) {
      if (typeof hero.stop === 'function') hero.stop();
      hero.querySelector('.anina-hero__controls')?.remove();
    }

    /* O carrossel já pode estar rodando: atualiza a lista dele e volta para o primeiro slide */
    if (typeof hero.go === 'function' && Array.isArray(hero.slides)) {
      hero.slides = slides;
      hero.dots = [...hero.querySelectorAll('[data-dot]')];
      if (slides.length) hero.go(0);
    } else if (slides[0] && !slides.some((s) => s.classList.contains('is-active'))) {
      slides[0].classList.add('is-active');
    }
  }
}

if (!customElements.get('anina-bf-banner')) customElements.define('anina-bf-banner', AninaBFBanner);
